import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { LanguageService } from './services/language.service';
import { IntercomService } from './services/intercom.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private langService: LanguageService,
    intercomService: IntercomService,
  ) {
    void intercomService;

    this.platform.ready().then(async () => {
      await this.langService.initializeLanguage();
    });
  }
}
